// extracted by mini-css-extract-plugin
export var fadeIn = "priorities-module--fadeIn--nobfP";
export var prioritiesBackground = "priorities-module--priorities-background--fXpzk";
export var prioritiesHeader = "priorities-module--priorities-header--fs5XF";
export var prioritiesRow = "priorities-module--priorities-row--Vjbg7";
export var prioritiesWrapper = "priorities-module--priorities-wrapper--JVgwJ";
export var priority = "priorities-module--priority--bFpzv";
export var priorityVisible = "priorities-module--priority--visible--G4uPG";